"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SegmentManager = SegmentManager;

var _react = _interopRequireDefault(require("react"));

var _dialog = require("@reach/dialog");

var _autoId = require("@reach/auto-id");

var _react2 = require("@headlessui/react");

var _managerBuilder = require("./manager-builder");

require("./consent-manager.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function SegmentManager(_ref) {
  var Link = _ref.linkComponent,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ["linkComponent", "children"]);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      dialogIsOpen = _React$useState2[0],
      setDialogIsOpen = _React$useState2[1];

  var dialogHeadingID = (0, _autoId.useId)();

  var openDialog = function openDialog() {
    return setDialogIsOpen(true);
  };

  var closeDialog = function closeDialog() {
    return setDialogIsOpen(false);
  };

  return /*#__PURE__*/_react["default"].createElement(_managerBuilder.ManagerBuilder, null, function (_ref2) {
    var allDestinations = _ref2.allDestinations,
        newDestinations = _ref2.newDestinations,
        isConsentRequired = _ref2.isConsentRequired,
        setCategoryFlag = _ref2.setCategoryFlag,
        setAllCategoryFlags = _ref2.setAllCategoryFlags,
        resetFromCookie = _ref2.resetFromCookie,
        saveToCookie = _ref2.saveToCookie,
        cookieDestinationFlags = _ref2.cookieDestinationFlags,
        cookieCategoryFlags = _ref2.cookieCategoryFlags,
        destinationFlags = _ref2.destinationFlags,
        categoryFlags = _ref2.categoryFlags,
        categories = _ref2.categories,
        haveFlagsChanged = _ref2.haveFlagsChanged;
    var isAlertNeeded = isConsentRequired && newDestinations.length > 0;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", _extends({
      type: "button"
    }, restProps, {
      onClick: function onClick() {
        openDialog();
      }
    }), children), isAlertNeeded ? /*#__PURE__*/_react["default"].createElement("aside", {
      className: "segment-banner prose-sans-s bg-ui-tertiary"
    }, /*#__PURE__*/_react["default"].createElement("h2", null, /*#__PURE__*/_react["default"].createElement("span", {
      role: "img",
      "aria-label": "Cookie Consent"
    }, "\uD83C\uDF6A")), /*#__PURE__*/_react["default"].createElement("p", null, "We collect and process your personal information for the following purposes: Visitor Statistics, Browsing Behavior.", ' ', /*#__PURE__*/_react["default"].createElement("button", {
      className: "link ui-fg",
      onClick: function onClick() {
        setAllCategoryFlags(true); // default to true, when opened from here !

        openDialog();
      }
    }, "Learn more...")), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn ui-fg",
      onClick: function onClick() {
        setAllCategoryFlags(true);
        saveToCookie();
      }
    }, "OK"))) : null, /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      className: "segment-dialog",
      isOpen: dialogIsOpen,
      onDismiss: closeDialog,
      "aria-labelledby": dialogHeadingID
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "segment-dialog-content scheme-summit bg-haiti ui-secondary"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "stack-m"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "prose-sans-s"
    }, /*#__PURE__*/_react["default"].createElement("h2", {
      className: "font-sans-m",
      id: 'headingID'
    }, "Information that we collect"), /*#__PURE__*/_react["default"].createElement("p", null, "Here you can see and customize the information that we collect about you. To learn more, please read our", ' ', /*#__PURE__*/_react["default"].createElement(Link, {
      to: "/privacy-policy",
      onClick: closeDialog
    }, "privacy policy"))), /*#__PURE__*/_react["default"].createElement("fieldset", {
      className: "segment-categories stack-xs"
    }, categories.map(function (category) {
      var needsReConsent = cookieCategoryFlags[category.id] && category.destinationIDs.some(function (destID) {
        return newDestinations.some(function (dest) {
          return dest.id == destID;
        });
      });
      var isEnabled = Boolean(categoryFlags[category.id]);
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: category.id,
        className: "stop"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "category ".concat(isEnabled ? 'enabled' : 'disabled'),
        onClick: function onClick() {
          return setCategoryFlag(_defineProperty({}, category.id, !categoryFlags[category.id]));
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "category-toggle"
      }, /*#__PURE__*/_react["default"].createElement(_react2.Switch, {
        as: "button",
        checked: isEnabled,
        onChange: function onChange(bool) {
          return setCategoryFlag(_defineProperty({}, category.id, bool));
        },
        className: "toggle-outer"
      }, function (_ref3) {
        var checked = _ref3.checked;
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "toggle-inner checked-".concat(checked)
        });
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "category-description"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "prose-sans-xs"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: ""
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "font-sans-s fw-bold"
      }, category.name), " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "font-sans-xs fw-400"
      }, "(", !isEnabled ? needsReConsent ? 'updated, disabled' : 'disabled' : 'enabled', ")")), /*#__PURE__*/_react["default"].createElement("p", null, category.description, " Uses", ' ', category.destinationIDs.map(function (id, i, arr) {
        var destination = allDestinations.find(function (d) {
          return id === d.id;
        }).name;
        var isNew = newDestinations.some(function (d) {
          return id === d.id;
        });
        return /*#__PURE__*/_react["default"].createElement("span", {
          key: id
        }, isNew ? /*#__PURE__*/_react["default"].createElement("em", null, destination) : destination, i < arr.length - 1 ? ', ' : '');
      }))))));
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "chain-s mt-l"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn-ghost ui-fg",
      onClick: function onClick() {
        saveToCookie();
        closeDialog();
      }
    }, "Save"), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn-ghost ui-fg",
      onClick: resetFromCookie
    }, "Reset"))))));
  });
}